<template>
    <vue-scroll v-if="form.list_two_items.length">
        <el-form>
            <el-form-item label="Headline">
                <el-input maxlength="25" v-model="form.list_2_headline" />
            </el-form-item>
            <table class="list-table">
                <thead>
                    <tr>
                        <th width="30"></th>
                        <th>Column One Info</th>
                        <th width="50"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, i) in form.list_two_items" :key="i">
                        <td>{{ i + 1 }}.</td>
                        <td>
                            <el-input maxlength="30" v-model="item.value" />
                        </td>
                        <td>
                            <el-button
                                size="small"
                                type="danger"
                                icon="mdi mdi-delete"
                                @click="removeItem(item)"
                            ></el-button>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td colspan="2">
                            <el-button
                                size="small"
                                type="primary"
                                round
                                icon="mdi mdi-plus"
                                @click="addItem()"
                                >Add Line
                            </el-button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </el-form>
    </vue-scroll>
</template>

<script>
export default {
    props: {
        newsletter: {
            required: true,
            type: Object
        },
        form: {
            type: Object,
            required: true
        }
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        addItem() {
            this.form.list_two_items.push({
                newsletter_id: this.newsletter.id,
                id: null,
                value: null
            });
            this.updateScroller();
        },
        removeItem(item) {
            this.$confirm(
                "Are you sure you want to remove item?",
                "Confirmation",
                {
                    type: "warning",
                    confirmButtonClass: "el-button--danger",
                    confirmButtonText: "Remove"
                }
            )
                .then(() => {
                    Utils.arrayDelete(this.form.list_two_items, item);
                    this.updateScroller();
                })
                .catch(() => {
                    //user cancelled
                });
        }
    }
};
</script>

<style scoped>
.list-table {
    width: 100%;
    border-collapse: collapse;
}

.list-table th {
    text-align: left;
    padding: 8px 5px;
    font-weight: bold;
}

.list-table td {
    padding: 5px;
}
</style>
